import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconFlipVerticalCircle12 from './IconFlipVerticalCircle12';
import IconFlipVerticalCircle16 from './IconFlipVerticalCircle16';
import IconFlipVerticalCircle20 from './IconFlipVerticalCircle20';
import IconFlipVerticalCircle24 from './IconFlipVerticalCircle24';
import IconFlipVerticalCircle32 from './IconFlipVerticalCircle32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconFlipVerticalCircle = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconFlipVerticalCircle12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconFlipVerticalCircle16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconFlipVerticalCircle20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconFlipVerticalCircle24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconFlipVerticalCircle32 {...props} />}
        </span>
    );
};
IconFlipVerticalCircle.displayName = 'FondueIconFlipVerticalCircle';

export default memo(IconFlipVerticalCircle);
